export const PLATFORMS = Object.freeze([
  {
    id: 'engagenet', name: 'Engagenet', monogram: 'E', color: '#4481eb',
    logo: require('@/assets/images/aic_one/logos/engagenet.svg'), app_code: 'Engagenet',
  },
  {
    id: 'aic_one', name: 'AIC One', monogram: 'A', color: '#C8102E',
    logo: require('@/assets/images/aic_one/logos/aicone_logo_v3.svg'), app_code: 'Home',
  },
  {
    id: 'orcaa', name: 'Orcaa.ai', monogram: 'Or', color: '#0E7CC4',
    logo: require('@/assets/images/aic_one/logos/orcaa.svg'), app_code: 'Orcaa',
  },
  {
    id: 'x-verdict', name: 'X-Verdict', monogram: 'X', color: '#84B440',
    logo: require('@/assets/images/aic_one/logos/xverdict.svg'), app_code: 'x-verdict',
  },
  {
    id: 'complyon', name: 'ComplyOn', monogram: 'C', color: '#B45309',
    logo: require('@/assets/images/aic_one/logos/complyon.svg'), app_code: 'complyon',
  },
  {
    id: 'complyon_onboard', name: 'Onboard', monogram: 'On', color: '#0F766E',
    logo: require('@/assets/images/aic_one/logos/oboarding.png'), app_code: 'complyon_onboard',
  },
  {
    id: 'workflow', name: 'Proba Workflows', monogram: 'PW', color: '#4338CA',
    logo: require('@/assets/images/aic_one/logos/proba.png'), app_code: 'Proba_workflows',
  },
  {
    id: 'proba', name: 'Proba Analytics', monogram: 'PA', color: '#BE123C',
    logo: require('@/assets/images/aic_one/logos/proba_white.svg'), app_code: 'Proba_analytics',
  },
]);

export const PLATFORM_IDS = Object.freeze(PLATFORMS.map((platform) => platform.id));
export const FALLBACK_PLATFORM_COLOR = '#6B5F60';

const PLATFORMS_BY_ID = Object.freeze(
  PLATFORMS.reduce((map, platform) => {
    map[platform.id] = platform;
    return map;
  }, {})
);

const PLATFORM_NAME_TO_ID = Object.freeze({
  'aic one': 'aic_one',
  aic_one: 'aic_one',
  'orcaa ai': 'orcaa',
  orcaa: 'orcaa',
  orca: 'orcaa',
  engagenet: 'engagenet',
  'ic workbook': 'engagenet',
  'x verdict': 'x-verdict',
  xverdict: 'x-verdict',
  complyon: 'complyon',
  'comply on': 'complyon',
  'complyon onboard': 'complyon_onboard',
  complyon_onboard: 'complyon_onboard',
  onboard: 'complyon_onboard',
  onboardid: 'complyon_onboard',
  'proba workflows': 'workflow',
  workflows: 'workflow',
  workflow: 'workflow',
  'proba analytics': 'proba',
  proba: 'proba',
  analytics: 'proba',
});

export function get_platform_config(platform_id) {
  return PLATFORMS_BY_ID[platform_id] || null;
}

export function platform_id_for_name(name) {
  const normalized = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[._-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return PLATFORM_NAME_TO_ID[normalized] || null;
}
